import Pokedex from 'pokedex-promise-v2';

const pokedex = new Pokedex();
export default pokedex;